/**
 * @packageDocumentation
 * Renders the initial sound preference popup, reusing autoplay art and blocking interaction until a choice is made.
 */
import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { brightnessFilter, font_main, HandleOrientation } from "./global";
import { overlay } from "../app";
import { SoundManager } from "./sounds";

export type SoundPromptOptions = {
  width: number;
  height: number;
  onChoice: (enabled: boolean) => void;
};

export class SoundPrompt extends PIXI.Container {
  // private readonly overlay: PIXI.Graphics;
  private readonly modal: PIXI.Container;
  private yesButton!: PIXI.Container;
  private noButton!: PIXI.Container;
  private resolved = false;
  private readonly choiceHandler: (enabled: boolean) => void;

  constructor(options: SoundPromptOptions) {
    super();
    this.choiceHandler = options.onChoice;
    this.sortableChildren = true;
    overlay.style.display = "block"; 
    this.modal = this.createModal(options.width, options.height);
    this.addChild(this.modal);
    HandleOrientation(this.PortraitAdjustFun.bind(this),this.landScapeAdjustFun.bind(this))
  }

  private createOverlay(width: number, height: number): PIXI.Graphics {
    const overlay = new PIXI.Graphics()
      .rect(0, 0, Math.max(width, 1), Math.max(height, 1))
      .fill({ color: 0x000000, alpha: 0.65})

    overlay.eventMode = "static";
    overlay.cursor = "default";
    overlay.zIndex = 0;
    return overlay;
  }

  private createModal(width: number, height: number): PIXI.Container {
    const container = new PIXI.Container();
    container.zIndex = 1;
    container.position.set(width / 2, height / 2);
    container.scale.set(0.45);
    const bg = new PIXI.Sprite(Assets.get("autoplay_bg"));
    bg.anchor.set(0.5);
    container.addChild(bg);
    const title = new PIXI.Text({
      text: "Enable Sound?",
      style: new PIXI.TextStyle({
        fontFamily: font_main,
        fontSize: 80,
        fontWeight: "900",
        fill: 0xffffff,
        align: "center",
        stroke: {
          color: "0x000000",
          width: 6,
          join: "round",
        },
        dropShadow: {
          color: "0x111111",
          blur: 4,
          distance: 3,
          angle: 0,
          alpha: 0.9,
        },
      }),
    });
    title.anchor.set(0.5);
    title.y = -142.64;
    container.addChild(title);

    const buttonTexture = Assets.get("but_autocount");
    const buttonYOffset = bg.height * 0.2;
    const buttonSpacing = buttonTexture.width * 1;

    this.yesButton = this.createButton(buttonTexture, "YES", 0x10ff00);
    this.yesButton.position.set(-buttonSpacing, buttonYOffset);
    this.attachButtonHandlers(this.yesButton, true);
    container.addChild(this.yesButton);

    this.noButton = this.createButton(buttonTexture, "NO", 0xff0000);
    this.noButton.position.set(buttonSpacing, buttonYOffset);
    this.attachButtonHandlers(this.noButton, false);
    container.addChild(this.noButton);
    // container.scale.set(0.8)
    return container;
  }

  private createButton(texture: PIXI.Texture, label: string, tint: number): PIXI.Container {
    const wrapper = new PIXI.Container();

    const sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5);
    sprite.tint = tint;

    wrapper.addChild(sprite);

    const text = new PIXI.Text({
      text: label,
      style: new PIXI.TextStyle({
        fontFamily: font_main,
        fontSize: 48,
        fontWeight: "900",
        fill: 0xffffff,
        align: "center",
        stroke: {
          color: "0x000000",
          width: 5,
          join: "round",
        },
      }),
    });
    text.anchor.set(0.5);
    wrapper.addChild(text);
    wrapper.scale.set(1.5);
    return wrapper;
  }

  private attachButtonHandlers(target: PIXI.Container, enabled: boolean) {
    target.eventMode = "static";
    target.cursor = "pointer";

    target.on("pointerover", () => {
      target.scale.set(1.55);
      target.filters = [brightnessFilter];
    });
    target.on("pointerout", () => {
      target.scale.set(1.5);
      target.filters = [];
    });
    target.on("pointertap", () => this.resolve(enabled));
  }

  private resolve(enabled: boolean) {
    if (this.resolved) {
      return;
    }
    if(enabled) SoundManager.Btnclick_1SndPlay(); 
    this.resolved = true;
    overlay.style.display = "none"; 
    this.yesButton.eventMode = "none";
    this.noButton.eventMode = "none";
    this.yesButton.cursor = "default";
    this.noButton.cursor = "default";

    this.choiceHandler(enabled);
  }
  PortraitAdjustFun(){
    if(this){
      this.scale?.set(0.725)
      this.position?.set(187,185) 
    }
  }  
  landScapeAdjustFun(){
    if(this){
      this.scale?.set(1)
      this.position?.set(0)
    }
  }
}



